"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAddressParsedResponse = void 0;
function transformAddressParsedResponse(address) {
    return {
        id: address.id,
        street: address.street,
        city: address.city,
        province: address.province,
        country: address.country,
        postalCode: address.postal_code,
    };
}
exports.transformAddressParsedResponse = transformAddressParsedResponse;
//# sourceMappingURL=Address.js.map